import { useState } from 'react';
import { PermissionGuard } from '@/features/auth';
import { SearchBar, Pagination, ButtonLink } from '@/shared/components';
import { useSecurityGroupsQuery } from '../hooks/useSecurityGroupsQuery';
import { SecurityGroupDataTable } from '../components/SecurityGroupDataTable';

export function SecurityGroupList() {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const resetPage = () => setPage(1);

  const query = useSecurityGroupsQuery({
    search: search.length >= 2 ? search : undefined,
    page,
    per_page: perPage,
  });

  const groups = query.data?.data ?? [];
  const meta = query.data?.meta;

  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Security Groups</h1>
        <PermissionGuard permission={{ resource: 'security_group', action: 'add' }}>
          <ButtonLink to="/admin/security-groups/new" size="sm">New Group</ButtonLink>
        </PermissionGuard>
      </div>

      <SearchBar
        searchTerm={search}
        setSearchTerm={(term) => { setSearch(term); resetPage(); }}
        placeholder="Search security groups"
      />

      <div className="space-y-4">
        <SecurityGroupDataTable
          data={groups}
          isLoading={query.isLoading}
        />

        {meta && meta.last_page > 1 && (
          <Pagination
            currentPage={meta.current_page}
            lastPage={meta.last_page}
            total={meta.total}
            perPage={meta.per_page}
            onPageChange={setPage}
            onPerPageChange={(n) => { setPerPage(n); setPage(1); }}
          />
        )}
      </div>
    </section>
  );
}
